import React, { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import HelpIcon from '../../../assets/icons/help';
import AppCheckbox from '../../../modules/app-checkbox/app-checkbox';
import Btn from '../../../modules/btn';
import IconBtn from '../../../modules/icon-btn/icon-btn';
import Modal from '../../../modules/modal';
import { RepeatableHintsType } from '../../../services/api/dto/Accounts';
import { setHintInfo } from '../../../store/actions/auth';
import { RootState } from '../../../types';

import { HINT_INFO } from './mock';

import './index.scss';

interface IHintModalProps {
  hint: RepeatableHintsType;
}

const HintModal: FC<IHintModalProps> = ({ hint }) => {
  const dispatch = useDispatch();

  const isVisible = useSelector((state: RootState) =>
    state.auth.profile.repeatableHints.includes(hint)
  );
  const position = useSelector(
    (state: RootState) => state.auth.profile.position
  );

  const [isVisibleModal, setVisibleModal] = useState(isVisible);

  const { title, description } = HINT_INFO(position)[hint];

  return (
    <div className="hint-modal">
      <IconBtn
        icon={<HelpIcon />}
        title="Помощь"
        onClick={() => setVisibleModal(!isVisibleModal)}
        sm
        outlined
        className="btn-icon--outlined"
      />
      <Modal
        open={isVisibleModal}
        onClose={() => setVisibleModal(!isVisibleModal)}
        header={<h4>{title}</h4>}
        body={<p>{description}</p>}
        footer={{
          left: (
            <AppCheckbox
              disabled={!isVisible}
              checked={!isVisible}
              onChangeValue={() =>
                dispatch(setHintInfo({ type: 'REPEATABLE', hint }))
              }
              title="Больше не показывать"
              sm
            />
          ),
          right: (
            <Btn
              onClick={() => setVisibleModal(false)}
              text="Понятно"
              buttonType="text"
              className="btn-modal"
            />
          ),
        }}
      />
    </div>
  );
};

export default HintModal;
